import { render, staticRenderFns } from "./StockBoard.vue?vue&type=template&id=abecebd0&scoped=true&"
import script from "./StockBoard.vue?vue&type=script&lang=js&"
export * from "./StockBoard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abecebd0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/piscinaFacilDev/piscinapp-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('abecebd0')) {
      api.createRecord('abecebd0', component.options)
    } else {
      api.reload('abecebd0', component.options)
    }
    module.hot.accept("./StockBoard.vue?vue&type=template&id=abecebd0&scoped=true&", function () {
      api.rerender('abecebd0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/analyzes/StockBoard.vue"
export default component.exports